import i18next from 'i18next';

const validate = (values) => {
  const errors = {};

  if (!values.email_address) {
    errors.email_address = i18next.t('errors:required');
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email_address)) {
    errors.email_address = i18next.t('errors:email');
  }

  return errors;
};

export default validate;
